import React from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";

// export const AuthGuard = ({ children }) => {
//   const storedToken = localStorage.getItem("User_Token");

//   if (storedToken && !axios.defaults.headers.common["Authorization"]) {
//     axios.defaults.headers.common["Authorization"] = `Bearer ${storedToken}`;
//   }

//   if (!storedToken) {
//     return <Navigate to="/login" replace />;
//   }

//   return children;
// };

export const AuthGuard = ({ children }) => {
  const token = localStorage.getItem("User_Token");
  const user = localStorage.getItem("Login_User");

  if (token && !axios.defaults.headers.common["Authorization"]) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  }

  if (!token || !user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};
